import PropTypes from 'prop-types';

const TopBarSchema = {
  personImage: PropTypes.string.isRequired,
};

export default { TopBarSchema };
